module.exports = "<ul class=\"vertical-tree-skeleton\">\n  <li *ngFor=\"let item of skeletonElements\">\n    <span></span>\n  </li>\n</ul>\n"